import { Helmet } from 'react-helmet';
import pageStyles from '../styles/page-common.module.css';


function NotFound() {

  return (
    <>
      <Helmet>
        <title>Page Not Found | LingoLeaf</title>
      </Helmet>
      <div className={pageStyles.styledPage}>
        <h1>Page not found, sorry!</h1>
      </div>
    </>
  );
}

export default NotFound;